import { createSlice } from "@reduxjs/toolkit";
import { getAll } from "./products.actions";

export const PRODUCTS_INITIAL_STATE = {
  products: [],
  isLoading: false,
  error: null,
};

export const productsSlice = createSlice({
  name: "products",
  initialState: PRODUCTS_INITIAL_STATE,
  reducers: {
    setProducts(state, action) {
      state.products = action.payload;
    },
    setIsLoading(state, action) {
      state.isLoading = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAll.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(getAll.fulfilled, (state, action) => {
      state.isLoading = false;
      state.products = action.payload || [];
      state.error = null;
    });
    builder.addCase(getAll.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message || "Failed to load products";
    });
  },
});

export const { setProducts, setProductsDetailed } = productsSlice.actions;

export const productsReducer = productsSlice.reducer;
